import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'metroRegion'
})
export class MetroRegionPipe implements PipeTransform {

  transform(valueArray: any[], state_id: string): any {
    if(state_id){
      return valueArray.filter(single=>single.state_id === state_id);
    } else {
      return [];
    }
  }

}
